import { track } from "jiffy-analytics";

import "./bulk-discount-toggle-rows.scss";

const initToggleBulkDiscountRows = () => {
  const $toggle = document.querySelector(".js-toggle-discount-rows");
  if (!$toggle) return;

  const $caret = document.querySelector(".js-toggle-caret");
  const $label = document.querySelector(".js-toggle-discount-label");

  $toggle.addEventListener("click", () => {
    track("dtf_discount_rows_clicked", {
      action: $label.textContent,
      catalog_number: $toggle.getAttribute("data-catalog-number")
    });
    $label.textContent = $label.textContent === "Show more" ? "Show less" : "Show more";
    const $discountRows = document.querySelectorAll(".js-blue-collapsible");
    $discountRows.forEach($row => {
      $row.classList.toggle("hidden");
    });
    $caret.classList.toggle("bulk-discount-toggle-rows__arrow--up");
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initToggleBulkDiscountRows();
});
